var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#10ACE3",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2,
    fill: "#F9F9F9",
    fillRule: "nonzero",
    width: 76,
    height: 76,
    rx: 38
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 31.761v20.891A1.34 1.34 0 0 0 27.333 54h21.334A1.34 1.34 0 0 0 50 52.652V24.35A1.34 1.34 0 0 0 48.667 23h-14c-.45 0-.927.179-1.248.498l-6.922 6.885c-.497.52-.497.931-.497 1.378z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.46 26.023v3.367c0 .745-.596 1.35-1.332 1.35h-3.334M42.935 36.522h-9.87M42.935 39.848h-9.87M42.935 43.174h-9.87M43.497 34a7.882 7.882 0 0 1 2.279 5.563c0 4.345-3.484 7.866-7.782 7.866-4.297 0-7.782-3.521-7.782-7.866 0-4.344 3.485-7.867 7.782-7.867 1.018 0 1.99.198 2.882.557M32.07 44.4 43.497 34"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContract);
export default __webpack_public_path__ + "static/media/no-contract.6bf4431a01939529c56f58cc96337463.svg";
export { ForwardRef as ReactComponent };